let links = document.querySelectorAll('a[href]:not([href^="#"]):not([target="_blank"]):not([href^="tel:"]):not([href^="mailto:"]):not(.jsProgressiveEnhancement)');

let pageOverlay = document.querySelector('.jsPageOverlay');

// Function to handle navigation with delay
function handleNavigation(event, url) {
	event.preventDefault();
	pageOverlay.showModal();

	setTimeout(() => {
		window.location.href = url;
	}, 850);
}

// Intercept link clicks
links.forEach(link => {
	link.addEventListener('click', function(event) {
		if (!event.defaultPrevented) {
			handleNavigation(event, this.href);
		}
	});
});

// Intercept form submissions
// document.querySelectorAll('form:not([method="dialog"]):not([sprig])').forEach(form => {
// 	form.addEventListener('submit', function(event) {
// 		if (!event.defaultPrevented) {
// 			event.preventDefault();
// 			pageOverlay.showModal();

// 			setTimeout(() => {
// 				this.submit(); // Proceed with the form submission
// 			}, 500);
// 		}
// 	});
// });